// import $ from "jquery";

const flowboxInstagram = () => {
  window.flowbox("init", {
    container: "#js-flowbox-flow",
    key: "AT-NsVpaTvyhqXaMIT6AQg",
    locale: "nl",
  });
};

try {
  flowboxInstagram();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
